import React from 'react';
import { IRichTextAccordions } from '../../interfaces/umbracoNodes/contentSlices';

import Accordion from './accordion';
import * as StyledRichTextAccordion from './richTextAccordions.styles';

interface Props {
	content: IRichTextAccordions;
}

const RichTextAccordions = ({ content }: Props) => {
	return (
		<StyledRichTextAccordion.Container>
			{<StyledRichTextAccordion.MainHeading>{content.Values.Title}</StyledRichTextAccordion.MainHeading>}
			{content.Values.Items.map(item => (
				<Accordion item={item} key={item.Values.Title} />
			))}
		</StyledRichTextAccordion.Container>
	);
};

export default RichTextAccordions;
